import React from 'react';
import { Navigate } from 'react-router-dom';
import { useWallet } from '../../context/WalletContext';
import useAdminRole from '../../hooks/useAdminRole';
import InlineLoader from './InlineLoader';

export default function RequireAdmin({ children }) {
  const { account } = useWallet();
  const { loading, allowed } = useAdminRole();

  if (!account) return <Navigate to="/" replace />;
  if (loading) {
    return (
      <div className="main-content">
        <InlineLoader size="lg" text="Verifying admin access..." />
      </div>
    );
  }
  if (!allowed) return <Navigate to="/dashboard" replace />;
  return children;
}
